import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Fuse from 'fuse.js';
import { Link } from 'react-router-dom';
import Avatar from 'components/common/Avatar';
import { isIterableArray } from 'helpers/utils';
import Flex from 'components/common/Flex';
import FalconCloseButton from 'components/common/FalconCloseButton';
import SoftBadge from 'components/common/SoftBadge';
import { ticketSearchByKeywords } from 'functions/ticket';
import moment from 'moment';

const MediaSearchContent = ({ item }) => {
  return (
    <Dropdown.Item className="px-x1 py-2" as={Link} to={item.url}>
      <Flex alignItems="center">
        {item.file && (
          <div className="file-thumbnail">
            <img src={item.img} alt="" className={item.imgAttrs.class} />
          </div>
        )}
        {item.icon && (
          <Avatar src={item.icon.img} size="l" className={item.icon.status} />
        )}

        <div className="ms-2">
          <h6 className="mb-0">{item.title}</h6>
          <p
            className="fs--2 mb-0"
            dangerouslySetInnerHTML={{ __html: item.text || item.time }}
          />
        </div>
      </Flex>
    </Dropdown.Item>
  );
};

const SearchBoxTickets = ({ }) => {
  const [dropdownOpen, setDropdownOpen] = useState(true);
  const [searchInputValue, setSearchInputValue] = useState('');
  const [resultItem, setResultItem] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

 // const [autoCompleteInitialItem,setAutoCompleteInitialItem] =useState([]);


  const searchTicketByKeyword=async(searchingValue)=>{
    setIsLoading(true);
    const autocompList=[];
    const seenMasterIds = new Set();
    if(searchingValue.length>0){
    const token=localStorage.getItem('token');
    const searchData={searchingValueKW:searchingValue,skip:null,limit:null};
    const res = await ticketSearchByKeywords(searchData,token);
    const { recordset, output } = res.data;
  
    recordset.forEach(r => {
      if (!seenMasterIds.has(r.TicketMasterId)) {
        seenMasterIds.add(r.TicketMasterId);
        autocompList.push(
          {
            id: r.TicketDetailId,
            catagories: 'suggestedFilters',
            url:`/support-desk/tickets-preview/${r.TicketMasterId}`,
            key: 'tickets',
            text: r.Subject+' | '+r.Description,
            type: 'success',
            messageDate:moment(r.MessageDate_UTC).format('hh:mm A DD MMM yy'), 
            ticketNo:r.TicketNumber
          }
        );
      }
    });
  }

    console.log('autocompList **',autocompList)
    setResultItem(autocompList);
    setIsLoading(false);
  }


  
  // const onSearchHandler=(value)=>{
  //   console.log('onSearchHandler',value)
  //   searchTicketByKeyword(value);
  // }

  useEffect(() => {
    if (searchInputValue) {
     setDropdownOpen(true);
     searchTicketByKeyword(searchInputValue);
    } else {
      setDropdownOpen(false);
    }
  }, [searchInputValue]);

  return (
    <Dropdown show={dropdownOpen} className="search-box">
    
      <Form className="position-relative">
        <Form.Control
          type="search"
          placeholder="Search..."
          aria-label="Search"
          className="rounded-pill search-input"
          value={searchInputValue}
          onChange={({ target }) => setSearchInputValue(target.value)}
         // onFocus={() => setDropdownOpen(true)}
         // onBlur={() => setDropdownOpen(false)}
        />
        <FontAwesomeIcon
          icon="search"
          className="position-absolute text-400 search-box-icon"
        />
        {(dropdownOpen || searchInputValue) && (
          <div className="search-box-close-btn-container">
            <FalconCloseButton
              size="sm"
              noOutline
              className="fs--2"
              onClick={() => {
                setSearchInputValue('');
                setDropdownOpen(false);
              }}
            />
          </div>
        )}
      </Form>
      <Dropdown.Menu>
        <div className="scrollbar py-3" style={{ maxHeight: '24rem' }}> 
            <>
              <Dropdown.Header as="h6" className="px-x1 pt-0 pb-2 fw-medium">
               {resultItem.length !== 0 &&`${resultItem.length} items found`}
              </Dropdown.Header>
              {resultItem.map(item => (
                <>
                <Dropdown.Item
                  as={Link}
                  to={item.url}
                   target="_blank"
                  className="fs-0 px-x1 py-1"
                  key={item.id}
                >
                  <Flex alignItems="center">
                  {/* <SoftBadge
                      bg="default"
                      className="fw-medium text-decoration-none me-2"
                    >
                      {item.TicketNumber}
                    </SoftBadge> */}
                       <SoftBadge
                      bg="primary"
                      className="fw-medium text-decoration-none me-2"
                    >
                      {item.messageDate}
                    </SoftBadge>
                    <div className="flex-1 fs--1">{item.text}</div>
                 
                  </Flex>
                </Dropdown.Item>
                </>
              ))}
           
            </>

          {resultItem.length === 0 && (
            <p className="fs-1 fw-bold text-center mb-0">No Result Found.</p>
          )}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
};

MediaSearchContent.propTypes = {
  item: PropTypes.shape({
    catagories: PropTypes.string,
    url: PropTypes.string.isRequired,
    icon: PropTypes.shape({
      img: PropTypes.string.isRequired,
      size: PropTypes.string,
      status: PropTypes.string
    }),
    title: PropTypes.string,
    text: PropTypes.string,
    img: PropTypes.string,
    time: PropTypes.string,
    file: PropTypes.bool,
    imgAttrs: PropTypes.shape({
      class: PropTypes.string
    })
  }).isRequired
};

// SearchBoxTickets.propTypes = {
//   autoCompleteItem: PropTypes.arrayOf(
//     PropTypes.shape(MediaSearchContent.propTypes.item)
//   )
// };

export default SearchBoxTickets;
